<template>
  <div class="read-card">
    <div style="width: 862px">
      <div class="card-header">
        <div class="title-wrap">
          <h4 class="title">{{ title || "知识点" }}</h4>
        </div>
        <div class="menu-wrap">
          <slot></slot>
        </div>
      </div>
      <div class="card-content">
        <div class="read-item">
          <span class="label">知识点名称：</span>
          <div class="value">
            <el-input v-model="name"
                      placeholder="输入知识点名称"
                      @change="handleItemNameChange"></el-input>
          </div>
        </div>
        <div class="read-item">
          <span class="label">重要程度：</span>
          <div class="value">
            <el-rate v-model="score"
                     :allow-half="true"
                     @change="handleScoreChange"></el-rate>
          </div>
        </div>
        <div class="read-item">
          <span class="label">资料类型：</span>
          <div class="value"
               style="display: flex; justify-content: space-between">
            <div class="box-type"
                 v-for="(item, index) in dataTypeList"
                 :key="index"
                 @click="handleMaterialTypeChange(index + 1)">
              <img :src="item.img"
                   alt="" />
              <div>{{ item.name }}</div>
              <img v-if="materialType == index + 1"
                   class="box-boder"
                   :src="require('/src/assets/img/box-border.png')"
                   alt="" />
            </div>

            <!-- <el-radio-group
            v-model="materialType"
            @change="handleMaterialTypeChange"
          >
            <el-radio :label="1">图文资料</el-radio>
            <el-radio :label="2">PDF资料</el-radio>
            <el-radio :label="3">视频资料</el-radio>
          </el-radio-group> -->
          </div>
        </div>

        <div class="read-item"
             v-if="materialType == 1">
          <span class="label"></span>
          <div class="value">
            <UEeditor :setDataStr="richText"
                      @change="handleRichTextChange" />
            <!-- <div v-if="isAuthor">
            <el-upload
              :action="imgUploadUrl"
              list-type="picture-card"
              :on-remove="handleRemove"
              :on-success="handleSuccess"
              :file-list="imgList"
              :on-preview="handlePictureCardPreview"
            >
              <i class="el-icon-plus"></i>
            </el-upload>
          </div>
          <UEeditor
            :setDataStr="richText"
            @change="handleRichTextChange"
            v-else
          /> -->
          </div>
        </div>
        <div class="read-item"
             v-if="materialType == 2">
          <span class="label"></span>
          <div class="value">
            <el-upload accept=".pdf"
                       class="uploader"
                       :action="fileUploadPrivateUrl"
                       :headers="uploadHeaders"
                       :show-file-list="true"
                       :file-list="fileList"
                       :before-upload="handleBeforeUpload"
                       :on-success="handleUploadSuccess">
              <el-button size="small"
                         type="primary"
                         icon="el-icon-upload2"
                         plain>点击上传</el-button><span style="margin-left:10px">只能上传pdf文件</span>
            </el-upload>
            <!-- <p class="tip">支持扩展名：.pdf</p> -->
            <!-- <div class="resource-box" v-if="resource.url">
              <el-link
                type="primary"
                :underline="false"
                @click="handleToDecrypt(resource.url)"
                >{{ resource.name }}</el-link
              >
            </div> -->
          </div>
        </div>
        <div class="read-item"
             v-if="materialType == 3">
          <span class="label"></span>
          <div class="value">
            <el-upload class="uploader"
                       accept=".doc,.docx,.xls,.xlsx"
                       :action="fileUploadPrivateUrl"
                       :headers="uploadHeaders"
                       :show-file-list="true"
                       :file-list="fileList"
                       :before-upload="handleBeforeUpload"
                       :on-success="handleUploadSuccess">
              <el-button size="small"
                         type="primary"
                         icon="el-icon-upload2"
                         plain>点击上传</el-button>
              <span style="margin-left:10px">只能上传doc，docx，xls，xlsx文件</span>
            </el-upload>
            <!-- <p class="tip">支持扩展名：.mp4</p>
            <div class="resource-box" v-if="resource.url">
              <el-link
                type="primary"
                :underline="false"
                @click="handleToDecrypt(resource.url)"
                >{{ resource.name }}</el-link
              >
            </div> -->
          </div>
          <!-- <div class="other-value">
          <UEeditor :setDataStr="richText" @change="handleRichTextChange" />
        </div> -->
        </div>

        <div class="read-item"
             v-if="materialType == 4">
          <span class="label"></span>
          <div class="value">
            <el-upload class="uploader"
                       accept=".mp4,.mkv,.mov,.mpeg,.3gp"
                       :action="fileUploadPrivateUrl"
                       :headers="uploadHeaders"
                       :show-file-list="true"
                       :file-list="fileList"
                       :before-upload="handleBeforeUpload"
                       :on-success="handleUploadSuccess">
              <el-button size="small"
                         type="primary"
                         icon="el-icon-upload2"
                         plain>点击上传</el-button>
              <span style="margin-left:10px">只能上传mp4，mkv，mov，mpeg，3gp文件</span>
            </el-upload>

          </div>
        </div>

        <div class="read-item"
             v-if="materialType == 5">
          <span class="label"></span>
          <div class="value">
            <!-- accept=".mp3,.wav,.cd,.aac,.aiff,.oog" -->
            <el-upload class="uploader"
                       accept=".mp3,.wav,.cd,.aac,.aiff,.oog"
                       :action="fileUploadPrivateUrl"
                       :headers="uploadHeaders"
                       :show-file-list="true"
                       :file-list="fileList"
                       :before-upload="handleBeforeUpload"
                       :on-success="handleUploadSuccess">
              <el-button size="small"
                         type="primary"
                         icon="el-icon-upload2"
                         plain>点击上传</el-button>
              <span style="margin-left:10px">只能上传mp3，wav，cd，aac，aiff，oog文件</span>
            </el-upload>

          </div>
        </div>

        <div class="read-item"
             v-if="[2,3].includes(materialType)">
          <span class="label">支持下载：</span>
          <div class="value">
            <el-switch @change="switchChange"
                       :value="support_download_status"></el-switch>
            <span style="color: #999999; margin-left: 11px">
              开启后学员可以自行下载该资料
            </span>
          </div>
        </div>

        <!-- <div class="line"></div> -->
        <!-- <span slot="footer" class="dialog-footer">
          <el-button type="primary" @click="dialogVisible = false"
            >确 定</el-button
          >
          <el-button @click="$router.go(-1)">取 消</el-button>   
        </span> -->
      </div>
    </div>
    <div class="preview">
      <div v-if="materialType == 1"
           @click="richText && previewOpen()"
           style=" overflow: hidden;padding:20px">
        <div v-html="richText"></div>
        <div class="empty"
             v-if="!richText">
          <img src="https://upload.kaoyanbox.net/5f1a5756dd420b84051c14a100859a36.png"
               alt="" />
          <div class="empty-word">暂无资料内容，请先在左侧填写</div>
        </div>
      </div>
      <div v-if="materialType == 2"
           @click.stop="url && previewOpen()">
        <iframe v-if="url"
                :src="url"
                frameborder="0"
                style="width: 100%; height: 100%"></iframe>
        <div style="
            width: 100%;
            height: 100%;
            position: absolute;
            top: 0;
            left: 0;
            z-index: 9999999;
          "></div>
        <div class="empty"
             v-if="!url">
          <img src="https://upload.kaoyanbox.net/5f1a5756dd420b84051c14a100859a36.png"
               alt="" />
          <div class="empty-word">暂无资料内容，请先在左侧填写</div>
        </div>
      </div>
      <div v-if="materialType == 3"
           @click.stop="url && previewOpen()">
        <iframe v-if="url"
                :src="url"
                style="width: 100%; height: 100%"></iframe>
        <div style="
            width: 100%;
            height: 100%;
            position: absolute;
            top: 0;
            left: 0;
            z-index: 9999999;
          "></div>
        <div class="empty"
             v-if="!url">
          <img src="https://upload.kaoyanbox.net/5f1a5756dd420b84051c14a100859a36.png"
               alt="" />
          <div class="empty-word">暂无资料内容，请先在左侧填写</div>
        </div>
      </div>

      <div v-if="materialType == 4">
        <div v-if="url">
          <div class="video"
               @click="previewOpen()">
            <video :src="url"
                   controls
                   loop
                   style="width: 100%; height: 212px;object-fit:cover"></video>
            <!-- <div class="play-btn" style="height:212px">
              <img
                src="https://upload.kaoyanbox.net/7690d3dafa81069f26242e7e263bf1e6.png"
                alt=""
              />
            </div> -->
          </div>
          <div class="videoTitle">
            <div>{{ paperName ||'暂无集合名称'}}</div>
            <img :src="require('/src/assets/img/in.png')"
                 alt="" />
          </div>
          <div class="videoTitle-word">
            <img :src="require('/src/assets/img/bofang.png')"
                 alt="" />
            <div>{{ name ||'暂无知识点名称'}}</div>
          </div>
        </div>
        <div class="empty"
             v-if="!url">
          <img src="https://upload.kaoyanbox.net/5f1a5756dd420b84051c14a100859a36.png"
               alt="" />
          <div class="empty-word">暂无资料内容，请先在左侧填写</div>
        </div>
      </div>

      <div v-if="materialType == 5"
           style="position: relative">
        <div v-if="url">
          <div class="video"
               @click="previewOpen()">
            <audio :src="url"
                   controls
                   loop
                   style="width: 100%; height: 212px"></audio>
            <div class="play-btn">
              <img src="https://upload.kaoyanbox.net/7690d3dafa81069f26242e7e263bf1e6.png"
                   alt="" />
            </div>
            <img class="imgpos"
                 src="https://upload.kaoyanbox.net/05fdb2caa41892a584deb46748da374e.png"
                 alt="" />
          </div>
          <div class="videoTitle">
            <div>{{ paperName ||'暂无集合名称'}}</div>
            <img :src="require('/src/assets/img/in.png')"
                 alt="" />
          </div>
          <div class="videoTitle-word">
            <img :src="require('/src/assets/img/icon-music.png')"
                 alt="" />
            <div>{{ name ||'暂无知识点名称'}}</div>
          </div>
        </div>
        <div class="empty"
             v-if="!url">
          <img src="https://upload.kaoyanbox.net/5f1a5756dd420b84051c14a100859a36.png"
               alt="" />
          <div class="empty-word">暂无资料内容，请先在左侧填写</div>
        </div>
      </div>
    </div>
    <el-dialog :visible.sync="dialogVisible">
      <img width="100%"
           :src="dialogImageUrl"
           alt="" />
    </el-dialog>

    <el-dialog class="dialog"
               :visible.sync="textDialogVisible"
               :before-close="handleClose"
               :width="[1, 2, 3].includes(materialType) ? '694px' : '1212px'">
      <div style="width: 100%; height: 936px;padding:20px"
           v-html="richText"
           v-if="materialType == 1"></div>
      <div style="width: 100%; height: 936px"
           v-if="materialType == 2 || materialType == 3">
        <iframe :src="url"
                frameborder="0"
                style="width: 100%; height: 100%"></iframe>
      </div>

      <div style="width: 100%; height: 738px"
           v-if="materialType == 4">
        <video ref="myVideo"
               :src="url"
               controls
               loop
               style="width: 100%; height: 100%;object-fit:cover"></video>
      </div>
      <div style="
          width: 100%;
          height: 738px;
          display: flex;
          justify-content: center;
          align-items: center;
        "
           v-if="materialType == 5">
        <audio ref="myAudio"
               :src="url"
               controls
               loop
               style="width: 50%; height: 60px"></audio>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import VueEditor from '@/components/VueEditor'
import { randomTimeNumber, getFileExtendingName } from '@/utils/helper'
import {
  fileUploadPrivateUrl,
  fileUploadUrl,
  uploadHeaders,
  imgUploadUrl,
} from '@/config/index'
import { uploadFileToken, resourceUpdate } from '@/api/common'
import UEeditor from '@/components/UEeditor'
import { readItemUpdate, uploadprivatesign } from '@/api/read'

let Timer = null // 定时器
let TimerTime = 500 // 定时器 等待时长

export default {
  components: {
    VueEditor,
    UEeditor,
  },
  props: {
    title: String,
    content: {
      type: Object,
      default: () => {
        return {}
      },
    },
    paper_id: {
      default: '',
    },
    paperName: {
      default: '',
    },
    isAuthor: {
      type: Boolean,
      default: () => {
        return false
      },
    },
  },
  data() {
    return {
      fileUploadUrl: fileUploadUrl(),
      fileName: '',
      textDialogVisible: false,
      url: '',
      support_download_status:
        this.content.support_download_status == 1 ? true : false,
      fileList: this.content.resource
        ? [
            {
              ...this.content.resource,
              name: this.content.resource.origin_name
                ? this.content.resource.origin_name
                : this.content.resource.name,
            },
          ]
        : [],
      fileUploadPrivateUrl: fileUploadPrivateUrl(),
      uploadHeaders: uploadHeaders(),
      imgUploadUrl: imgUploadUrl(),
      keys: `ABCDEFGHIJKLMNOPQRSTUVWXYZ`.split(''),
      name: this.content.name || '',
      score: this.content.score || 0,
      materialType: this.content.material_type || 1,
      richText: this.content.rich_text || '',
      resource: this.content.resource || {},
      imgList: [],
      dialogImageUrl: '',
      dialogVisible: false,
      dataTypeList: [
        {
          name: '图文资料',
          img: require('/src/assets/img/image.png'),
        },
        {
          name: 'PDF资料',
          img: require('/src/assets/img/PDF.png'),
        },
        {
          name: 'Word资料',
          img: require('/src/assets/img/word.png'),
        },
        {
          name: '视频资料',
          img: require('/src/assets/img/video.png'),
        },
        {
          name: '音频资料',
          img: require('/src/assets/img/musci.png'),
        },
      ],
    }
  },
  // watch: {
  //   isAuthor(val) {
  //     console.log('val:', this.content)

  //   },
  // },
  mounted() {
    if (this.isAuthor) {
      if (this.materialType == 1) {
        this.imgList = this.content.rich_text
          ? JSON.parse(this.content.rich_text)
          : []
      }
    }
  },
  created() {
    // console.log("created:",this.content);
    this.$nextTick(() => {
      if (this.materialType != 1 && this.content.resource) {
        this.getUploadprivatesign(this.content.resource.name)
      }
    })
  },

  methods: {
    handleClose() {
      if (this.materialType == 4) {
        this.$refs.myVideo.pause()
      }
      if (this.materialType == 5) {
        this.$refs.myAudio.pause()
      }
      this.textDialogVisible = false
    },
    previewOpen() {
      this.textDialogVisible = true
      if (this.materialType == 4) {
        this.$nextTick(() => {
          this.$refs.myVideo.play()
        })
      }
      if (this.materialType == 5) {
        this.$nextTick(() => {
          this.$refs.myAudio.play()
        })
      }
    },
    getUploadprivatesign(name) {
      if (name) {
        let query = {
          product_id: this.$route.params.readId,
          name: name,
          paper_id: this.paper_id,
        }

        console.log('this.content', this.content)
        if (this.content.resource && !this.content.resource.origin_name) {
          this.url = this.content.resource.url
          console.log('url', this.url)
          return
        }

        uploadprivatesign(query).then((res) => {
          console.log('reskk', res)
          this.url = 'https' + res.split('http')[1]
          console.log('this.url', this.url)
          if (this.materialType == 3) {
            this.url = `https://view.officeapps.live.com/op/view.aspx?src=${encodeURIComponent(
              this.url
            )}`
            // "https://view.officeapps.live.com/op/view.aspx?src=" + this.url;
          }
          console.log('this.url:', this.url)
        })
      }
    },
    switchChange(e) {
      readItemUpdate({
        id: this.content.item_id,
        support_download_status: !this.support_download_status,
      })
        .then((res) => {
          this.support_download_status = !this.support_download_status
          // if (res.resource_id) {
          //   this.resource.id = res.resource_id;
          // }
          // // 数据向外层传递
          // this.handleExamSave();
        })
        .catch((error) => {
          this.$message.error('下载设置更新异常')
          console.log('error: ', error)
        })
      console.log('e:', e)
    },
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url
      this.dialogVisible = true
    },
    handleRemove(file, fileList) {
      this.imgList = fileList
      setTimeout(() => {
        readItemUpdate({
          id: this.content.item_id,
          rich_text: JSON.stringify(this.imgList),
        })
          .then((res) => {
            // 数据向外层传递
            this.handleExamSave()
          })
          .catch((error) => {
            this.$message.error('图文材料更新异常')
            console.log('error: ', error)
          })
      }, 500)
    },
    handleSuccess(response, file, fileList) {
      this.imgList.push({
        size: file.size,
        type: 'image',
        url: response.data.url,
      })
      setTimeout(() => {
        readItemUpdate({
          id: this.content.item_id,
          rich_text: JSON.stringify(this.imgList),
        })
          .then((res) => {
            // 数据向外层传递
            this.handleExamSave()
          })
          .catch((error) => {
            this.$message.error('图文材料更新异常')
            console.log('error: ', error)
          })
      }, 500)
    },
    // 资料类型变化
    handleMaterialTypeChange(value) {
      // console.log("value:", value);
      // console.log("content:", this.content);

      if (this.url || this.richText) {
        this.$confirm('继续切换将清空当前内容, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        }).then(() => {
          this.richText = ''
          this.url = ''
          this.fileList = []
          this.materialType = value
          this.getreadItemUpdate(value, 1)
        })
      } else {
        this.materialType = value
        this.getreadItemUpdate(value, 1)
      }
    },
    getreadItemUpdate(value, is_force_clean_resource) {
      readItemUpdate({
        id: this.content.item_id,
        material_type: value,
        is_force_clean_resource: is_force_clean_resource
          ? is_force_clean_resource
          : '',
      })
        .then((res) => {
          if (res.resource_id) {
            this.resource.id = res.resource_id
          }
          // 数据向外层传递
          this.handleExamSave()
        })
        .catch((error) => {
          this.$message.error('资料类型更新异常')
          console.log('error: ', error)
        })
    },
    // 分值变化
    handleScoreChange(value) {
      readItemUpdate({ id: this.content.item_id, score: value })
        .then((res) => {
          // 数据向外层传递
          this.handleExamSave()
        })
        .catch((error) => {
          this.$message.error('重要程度更新异常')
          console.log('error: ', error)
        })
    },
    // 文件上传前处理
    handleBeforeUpload(file) {
      this.fileName = file.name
      // console.log('file:', file)
      return true
    },
    // 文件上传成功回调
    handleUploadSuccess(res, file) {
      console.log('file:', file)
      this.getUploadprivatesign(res.data.name)
      this.fileList = [{ ...res.data, name: this.fileName }]
      if (res.code == 0 && res.data) {
        if (this.resource.id) {
          let values = {
            origin_name: this.fileName,
            id: this.resource.id,
            name: res.data.name,
            key: res.data.url + '*',
            url: res.data.url + '*',
            size: file.size,
            type: 1,
          }
          console.log('value', values)
          if (file.raw && file.raw.type) {
            values['mime_type'] = file.raw.type
          }
          resourceUpdate(values)
            .then((res2) => {
              this.resource = res2
              // this.fileList = [];
              // 数据向外层传递
              this.handleExamSave()
            })
            .catch((error) => {
              this.$message.error('更新异常')
              console.log('error: ', error)
            })
        }
      } else {
        this.$message.error(res.error)
      }
    },
    // 知识点名称变动
    handleItemNameChange(value) {
      this.name = value
      clearTimeout(Timer)
      readItemUpdate({ id: this.content.item_id, name: this.name })
        .then((res) => {
          // 数据向外层传递
          this.handleExamSave()
        })
        .catch((error) => {
          this.$message.error('知识点名称更新异常')
          console.log('error: ', error)
        })
    },
    // 图文资料
    handleRichTextChange(e) {
      this.richText = e
      clearTimeout(Timer)
      Timer = setTimeout(() => {
        readItemUpdate({ id: this.content.item_id, rich_text: this.richText })
          .then((res) => {
            this.getreadItemUpdate(this.materialType)
            // 数据向外层传递
            this.handleExamSave()
          })
          .catch((error) => {
            this.$message.error('图文材料更新异常')
            console.log('error: ', error)
          })
      }, TimerTime)
    },
    handleExamSave() {
      this.$emit('save', {
        name: this.name,
        rich_text: this.richText,
        material_type: this.materialType,
        resource: this.resource,
      })
    },
    // handleToDecrypt(url) {
    //   let is_sign = url.substr(url.length - 1, 1);
    //   if (is_sign == "*") {
    //     let lastUrl = url.slice(0, url.length - 1).split("/")[3];
    //     let query = {
    //       product_id: this.$route.params.readId,
    //       name: lastUrl.replace("https:", window.location.protocol),
    //       paper_id: this.$route.params.chapterId,
    //     };
    //     uploadprivatesign(query).then((res) => {
    //       window.open(res);
    //     });
    //   } else {
    //     window.open(url);
    //   }
    // },
  },
}
</script>

<style scoped lang="less">
/deep/.edui-default .edui-editor {
  z-index: 999 !important;
}

.dialog {
  /deep/.el-dialog__header {
    padding: 0 !important;
  }
  /deep/.el-dialog__body {
    padding: 0 !important;
  }
  /deep/.el-dialog__headerbtn {
    width: 24px;
    height: 24px;
    background: white;
    border-radius: 50%;
    top: -14px;
    right: -17px;
  }
}
.read-card {
  position: relative;
  color: #303133;
  border: 1px solid #ebeef5;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  border-radius: 4px;
  overflow: hidden;
  background: white;
  padding: 20px;
  display: flex;
  .card-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 10px;

    .title-wrap {
      display: flex;
      .title {
        font-size: 18px;
        font-weight: bold;
        color: #0091ff;
        margin-right: 20px;
      }
      /deep/ .el-radio {
        margin-right: 20px;
      }
      /deep/ .el-radio__label {
        padding-left: 5px;
      }
    }
    .menu-wrap {
      display: flex;
      align-items: center;

      /deep/ .el-button {
        padding-top: 0;
        padding-bottom: 0;
      }
    }
  }
  .line {
    background: #f0f0f0;
    width: 100%;
    height: 1px;
    margin-top: 40px;
    margin-bottom: 28px;
  }
  .preview {
    flex: auto;
    flex-shrink: 0;
    position: relative;
    & > div {
      width: 294px;
      height: 636px;
      border-radius: 16px;
      border: 8px solid rgba(0, 0, 0, 0.85);
      margin-left: 305px;
      position: relative;
    }
    .video {
      position: relative;
      .play-btn {
        width: 100%;
        height: 100%;
        position: absolute;
        top: 0;
        left: 0;
        display: flex;
        justify-content: center;
        align-items: center;
        z-index: 999;
      }
      img {
        width: 56px;
        height: 56px;
      }
    }
    .empty {
      width: 100%;
      height: 240px;
      position: absolute;
      top: 0;
      left: 0;
      z-index: 9999;
      left: 0;
      top: 50%;
      transform: translateY(-50%);
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      img {
        width: 202px !important;
        height: 118px !important;
      }
      .empty-word {
        margin-top: 12px;
        font-size: 12px;
        font-family: PingFangSC, PingFang SC;
        font-weight: 400;
        color: rgba(0, 0, 0, 0.65);
        line-height: 17px;
      }
    }
    .videoTitle {
      display: flex;
      align-items: center;
      justify-content: space-between;
      font-size: 16px;
      font-family: PingFangSC, PingFang SC;
      font-weight: 600;
      color: #333333;
      line-height: 22px;
      margin: 16px 16px 0 16px;
      padding-bottom: 16px;
      border-bottom: 1px solid #f5f5f5;
      img {
        width: 16px;
        height: 16px;
      }
    }
    .videoTitle-word {
      display: flex;
      align-items: center;

      font-size: 14px;
      font-family: PingFangSC, PingFang SC;
      font-weight: 400;
      color: #1f86fe;
      line-height: 20px;
      margin: 16px 16px 0 16px;
      padding-bottom: 16px;

      img {
        width: 16px;
        height: 16px;
        margin-right: 2px;
      }
    }
    .imgpos {
      width: 100% !important;
      height: 212px !important;
      position: absolute;
      top: 0;
      left: 0;
      z-index: 99;
    }
  }
  .card-content {
    margin-top: 20px;
  }
  .read-item {
    display: flex;
    min-height: 32px;
    flex-wrap: wrap;

    & + .read-item {
      margin-top: 15px;
    }

    .label {
      width: 90px;
      line-height: 32px;
      // text-align: right;
      // margin-right: 10px;
    }
    .value {
      display: flex;
      align-items: center;
      flex: 1;
      width: 100%;
    }
    .box-type {
      cursor: pointer;
      width: 140px;
      height: 72px;
      border: 1px solid #d9d9d9;
      display: flex;
      align-items: center;
      justify-content: center;
      & > img {
        width: 24px;
        height: 24px;
        margin-right: 4px;
      }
      // margin-right: 16px;
      position: relative;
      .box-boder {
        width: 140px !important;
        height: 72px !important;
        position: absolute;
        top: 0;
        left: 0;
      }
    }

    .box-type:nth-of-type(5) {
      img {
        width: 20px;
        height: 24px;
      }
    }

    .tip {
      font-size: 12px;
      color: #999;
      margin-left: 10px;
    }
    .other-value {
      margin-top: 16px;
      width: 100%;
      margin-left: 90px;
    }
  }
  .resource-box {
    margin-left: 20px;

    a {
      color: #409eff;
      text-decoration: underline;
    }
  }
  .vueEditor {
    width: 100%;

    /deep/ .ql-container {
      min-height: 80px;
    }
  }
}
</style>
